<template>
    <div v-loading="fullLoading">
        <el-row>
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
                <el-form :inline="true">
                    <el-form-item align="right">
                        <el-button type="info" size="medium" @click="addAlarmClick()">Add Alarm</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table :data="alarmsTable" stripe style="width: 100%; margin-bottom: 10px; font-size: 1rem"
                    @cell-click="alarmEditClick" cell-class-name="cellStyle">
                    <!-- <el-table-column v-show="false" :min-width="70" prop="noteId" label="ID"></el-table-column> -->
                    <el-table-column :min-width="150" prop="name" label="Name" sortable></el-table-column>
                    <el-table-column :min-width="200" prop="alarm_type_name" label="Alarm Type"
                        sortable></el-table-column>
                    <el-table-column label="Enabled" width="100">
                        <template scope="scope">
                            <div v-if="scope.row.enabled == 0"><el-tag type="info">Disabled</el-tag>
                            </div>
                            <div v-else><el-tag type="success">Enabled</el-tag></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Current State" width="150">
                        <template scope="scope">
                            <div v-if="scope.row.state == 0"><el-tag type="info">Reset</el-tag>
                            </div>
                            <div v-else><el-tag type="danger">Triggered</el-tag></div>
                        </template>
                    </el-table-column>

                    <el-table-column :min-width="70" prop="threshold" label="Threshold"></el-table-column>
                    <el-table-column :min-width="70" prop="hysterisis" label="Hysterisis"></el-table-column>
                    <el-table-column :min-width="150" prop="firedAtFormatted" label="Last Triggered"></el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <h3>Zone Alarm Log</h3>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table :data="alarmLogTable" stripe style="width: 100%; margin-bottom: 10px; font-size: 1rem"
                    cell-class-name="cellStyle">
                    <!-- <el-table-column v-show="false" :min-width="70" prop="noteId" label="ID"></el-table-column> -->
                    <el-table-column :min-width="150" prop="name" label="Alarm Name" sortable></el-table-column>
                    <el-table-column :min-width="150" prop="alarm_type_name" label="Alarm Type"
                        sortable></el-table-column>
                    <el-table-column :min-width="150" prop="triggeredAtFormatted"
                        label="Last Triggered"></el-table-column>
                </el-table>
            </el-col>
        </el-row>



        <el-row>
            <el-dialog title="Alarm" :visible.sync="alarmDialog.visible">
                <el-form :model="alarmDialog.form" v-loading="alarmDialog.loading" @submit.native.prevent>

                    <el-form-item v-if="alarmDialog.form.newAlarm" label="Alarm Type">
                        <el-select v-model="alarmDialog.form.alarmTypeId" placeholder="Select" style="width: 240px"
                            @change="alarmTypeChange()">
                            <el-option v-for="item in alarmTypes" :key="item.value" :label="item.label"
                                :value="item.value" />
                        </el-select>
                    </el-form-item>

                    <el-form-item label="Name">
                        <el-input v-model="alarmDialog.form.name" />
                    </el-form-item>
                    <el-form-item label="Enabled">
                        <el-switch v-model="alarmDialog.form.enabled" />
                    </el-form-item>
                    <el-form-item v-if="alarmDialog.threshold.visible" :label="alarmDialog.threshold.label">
                        <el-input v-model="alarmDialog.form.threshold" />
                    </el-form-item>
                    <el-form-item v-if="alarmDialog.hysterisis.visible" :label="alarmDialog.hysterisis.label">
                        <el-input v-model="alarmDialog.form.hysterisis" />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" style="margin-top: 10px"
                            @click="alarmDialog.visible = false">Cancel</el-button>
                        <el-button type="primary" style="margin-top: 10px" @click="AlarmDialogHandler">Save</el-button>
                        <el-button v-if="!alarmDialog.form.newAlarm" type="primary"
                            style="margin-top: 10px; float:right;" @click="AlarmDeleteHandler">Delete Alarm</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </el-row>
    </div>
</template>

<script>
import Axios from "axios"
import AlarmsService from "@/api/alarms.service"
import ApartmentsService from "@/api/apartments.service"
import util from '../common/js/util'

export default {
    components: {},
    props: {},
    data() {
        return {
            fullLoading: false,
            user: this.$session.get("User"),
            alarmDialog: {
                visible: false,
                idVisible: false,
                form: {
                    id: "ddddd",
                    enabled: "",
                    threshold: "",
                    hysterisis: "",
                    name: "",
                    alarmTypeId: 1,
                    newAlarm: false
                },
                timeout: 0,
                loading: false,
                threshold: {
                    label: "Threshold (°F)",
                    visible: true
                },
                hysterisis: {
                    label: "Hysterisis (°F)",
                    visible: true
                }
            },
            dataLoaded: false,
            alarmsTable: [
            ],
            alarmLogTable: [],
            alarmTypes: [
                {
                    value: 1,
                    label: 'Flood Alarm',
                },
                {
                    value: 2,
                    label: 'Domestic Water High Temperature',
                },
                {
                    value: 3,
                    label: 'Domestic Water Low Temperature',
                },
                {
                    value: 4,
                    label: 'Boiler High Pressure',
                },
                {
                    value: 5,
                    label: 'Boiler Low Pressure',
                },
                {
                    value: 6,
                    label: 'Stack High Temperature',
                },
                {
                    value: 7,
                    label: 'Stack Low Temperature',
                },
            ]
        }
    },
    methods: {
        handleAlarmDialogFormat(alarmTypeId) {
            switch (alarmTypeId) {
                case 1:
                    this.alarmDialog.threshold.visible = false
                    this.alarmDialog.hysterisis.visible = false
                    break;
                case 2:
                case 3:
                case 6:
                case 7:
                    this.alarmDialog.threshold.visible = true
                    this.alarmDialog.hysterisis.visible = true
                    this.alarmDialog.threshold.label = "Threshold (°F)"
                    this.alarmDialog.hysterisis.label = "Hysterisis (°F)"
                    break;
                case 4:
                case 5:
                    this.alarmDialog.threshold.visible = true
                    this.alarmDialog.hysterisis.visible = true
                    this.alarmDialog.threshold.label = "Threshold (PSI)"
                    this.alarmDialog.hysterisis.label = "Hysterisis (PSI)"
                    break;
            }
        },
        alarmTypeChange() {
            console.log("David")
            this.handleAlarmDialogFormat(this.alarmDialog.form.alarmTypeId)
        },
        AlarmDeleteHandler() {
            AlarmsService.deleteZoneAlarm(this.alarmDialog.form.id).then(() => {
                this.getData();
            })
            this.alarmDialog.visible = false
        },
        addAlarmClick() {
            this.alarmDialog.form.note = "";
            //Clear the dialog                        
            this.alarmDialog.form.enabled = false;
            this.alarmDialog.form.threshold = null
            this.alarmDialog.form.hysterisis = null
            this.alarmDialog.form.name = ""
            this.alarmDialog.form.newAlarm = true;
            this.alarmDialog.form.alarmTypeId = 1;   //Default to flood
            this.handleAlarmDialogFormat(this.alarmDialog.form.alarmTypeId)
            this.alarmDialog.visible = true
        },
        alarmEditClick(row, column, cell, event) {
            this.alarmDialog.form.id = row.id;
            this.alarmDialog.form.enabled = row.enabled == 1;
            this.alarmDialog.form.threshold = row.threshold;
            this.alarmDialog.form.hysterisis = row.hysterisis;
            this.alarmDialog.form.name = row.name;
            this.alarmDialog.form.newAlarm = false;
            this.alarmDialog.form.alarmTypeId = row.alarm_type_id


            this.handleAlarmDialogFormat(this.alarmDialog.form.alarmTypeId)
            this.alarmDialog.visible = true
        },
        sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms))
        },

        AlarmDialogHandler() {
            if (this.alarmDialog.form.newAlarm) {
                AlarmsService.addZoneAlarm(this.user.activeZone, this.alarmDialog.form.alarmTypeId, this.alarmDialog.form.name, this.alarmDialog.form.enabled, this.alarmDialog.form.threshold, this.alarmDialog.form.hysterisis).then(() => {
                    this.getData();
                })
            } else {
                AlarmsService.updateZoneAlarm(this.alarmDialog.form.id, this.alarmDialog.form.name, this.alarmDialog.form.enabled, this.alarmDialog.form.threshold, this.alarmDialog.form.hysterisis).then(() => {
                    this.getData();
                })
            }
            this.alarmDialog.visible = false
        },


        onSubmit() {
            console.log("submit!")
        },

        getData() {
            if (!this.$auth.isAuthenticated()) this.$auth.login()
            //Axios.defaults.baseURL = 'http://192.168.137.233:3000';
            Axios.all([
                AlarmsService.getZoneAlarms(this.user.activeZone),
                AlarmsService.getZoneAlarmLog(this.user.activeZone),
            ])
                .then(
                    Axios.spread((ZoneAlarmsResponse, ZoneAlarmLogResponse) => {
                        console.log(ZoneAlarmsResponse.data)
                        this.alarmsTable = ZoneAlarmsResponse.data
                        for (var entry of this.alarmsTable) {
                            if (entry.firedAt) {
                                entry.firedAtFormatted = util.formatDate.format(new Date(entry.firedAt), 'yyyy-MM-dd hh:mm')
                            }
                        }
                        this.alarmLogTable = ZoneAlarmLogResponse.data
                        for (var entry of this.alarmLogTable) {
                            if (entry.triggeredAt) {
                                entry.triggeredAtFormatted = util.formatDate.format(new Date(entry.triggeredAt), 'yyyy-MM-dd hh:mm')
                            }
                        }
                        this.dataLoaded = true
                    })
                )
                .catch((err) => {
                    this.sysHeatStatusTable[0].network = "Error in Server and/or Panel"
                    console.log(err)
                })
        }

    },
    created() { },
    mounted() {
        this.getData()
        //this.polling = setInterval(this.getData, 10000)
    },
    beforeDestroy() {
        //clearInterval(this.polling)
    }
}
</script>

<style>
.el-table td {
    font-size: medium;
    white-space: pre-wrap;
    word-wrap: break-word
}

.el-table__body-wrapper {
    overflow: hidden;
}

.el-table .cell {
    white-space: pre-wrap
}
</style>



// WEBPACK FOOTER //
// ZoneAlarms.vue?7555977c